module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-coupon/bg.png",
      "swiper": _vm.swiper,
      "hasDownBtn": true
    }
  }, [_c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [(_vm.data.registrationDateYear > 0) ? _c('span', [_c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.registrationDateYear) + "年")]), _vm._v("以来"), _c('br')]) : _vm._e(), _vm._v("\n    感谢您一路的支持"), _c('br'), _vm._v("\n    送您一张"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.discountMoney || 99) + "元")]), _vm._v("定制病毒无门槛优惠券"), _c('br'), _vm._v("\n    可叠加二十二周年活动折扣使用\n  ")]), _vm._v(" "), _c('img', {
    staticClass: "main-image ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-coupon/shape1.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-image-coupon ani",
    staticStyle: {
      "background": "url(/static/img/anniversary/page-coupon/coupon.png)",
      "background-size": "cover"
    },
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_c('div', {
    staticClass: "main-image-coupon-inner"
  }, [_c('span', {
    staticClass: "money"
  }, [_vm._v(_vm._s(_vm.data.discountMoney || 99))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22d8b2ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anniversary/PageCoupon/index.vue
// module id = 1568
// module chunks = 8